export default __webpack_public_path__ + "static/media/contact4M.8b0b234c.webp";